

class ProductInfoNavigationBar extends HTMLElement {
    constructor() {
        super();
        this.section = this.closest('.shopify-section');
        this.noOfLinks = this.dataset.numberOfLinks;
        this.con = this.querySelector('.product-info-nav-bar');
        let previousSection = this.section;
        let hiddenLinkCount = 0
        //For each block in the section, apply a link to each section below the nav bar
        for (let i = 0; i < this.noOfLinks; i++) {
            const sectionForLink = previousSection.nextSibling;
            const link = document.querySelector('#product-info-nav-bar__link-' + i);
            if (sectionForLink.childElementCount === 0) {
                //If section is empty, hide the link
                link.closest('.product-info-nav-bar__block').style.display = 'none'
                hiddenLinkCount += 1;
                previousSection = sectionForLink;
            } else if (link) {
                //Else update link to point to the section
                link.href = '#' + sectionForLink.id;
                previousSection = sectionForLink;
            }
        }
        let noOfVisibleLinks = Number(this.con.dataset.noOfVisibleLinks) - hiddenLinkCount;
        if (hiddenLinkCount > 0) {
            this.con.dataset.noOfVisibleLinks = noOfVisibleLinks;
        }
        if (noOfVisibleLinks > 1) {
            //Nav bar can be revealed once the links are populated
            this.classList.add('product-info-nav-bar--hydrated');
        }

        //Ensures the links always mean you scroll to the sections location, even if the section is already semi visible
        this.querySelectorAll('a').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                const target = document.querySelector(this.getAttribute('href'));
                window.scrollTo({
                    top: target.offsetTop,
                    behavior: 'smooth'
                });
            });
        });

        //Update which link is active depending on the scroll position
        window.addEventListener('scroll', () => {
            const headerHeight = Number(window.getComputedStyle(window.document.documentElement).getPropertyValue('--theme-header-height').slice(0, -2));
            const navbarHeight = this.offsetHeight;
            //Additional height helps it better match section you feel like you are in
            const additionalHeight = 50;
            const headerNavHeight = headerHeight + navbarHeight + additionalHeight;

            let previousSection = this.section;

            //Loop over to see if window is positioned over any of the sections
            for (let i = 0; i < this.noOfLinks; i++) {
                const section = previousSection.nextSibling;
                const sectionTop = section.getBoundingClientRect().top;
                const sectionHeight = section.offsetHeight;

                //If positioned over a section, make its link in the nav bar active  
                if (headerNavHeight >= sectionTop && headerNavHeight < sectionTop + sectionHeight) {
                    const link = document.querySelector('#product-info-nav-bar__link-' + i);
                    if (!link.classList.contains('product-info-nav-bar__link--active')) {
                        document.querySelector('.product-info-nav-bar__link--active').classList.remove('product-info-nav-bar__link--active');
                        link.classList.add('product-info-nav-bar__link--active');
                    }
                    break;
                }
                previousSection = section;
            }
        });
    }
}
customElements.define('product-info-nav-bar', ProductInfoNavigationBar);